<template>
  <section class="community">
    <div class="ui-wrapper">
      <h2 class="section-title">
        {{ $t('components.home.old.community.title') }}
      </h2>

      <div class="community__content">
        <div class="community__left">
          <TransitionGroup
            name="scroll-top"
            class="community__cards"
            tag="div"
            @leave="onLeave"
          >
            <div
              v-for="card in communityCards"
              :key="card.id"
              class="community__card"
            >
              <div class="community__card-inner">
                <div
                  class="community__card-avatar"
                  :class="card.info ? `community__card-avatar_${card.info}` : ''"
                >
                  <img
                    v-if="card.avatarUrl"
                    class="community__card-avatar-image"
                    :src="card.avatarUrl"
                    :alt="card.avatarUrl"
                  >
                </div>

                <div class="community__card-content">
                  <div
                    v-if="card.title"
                    class="community__card-title"
                  >
                    {{ card.title }}
                  </div>

                  <p
                    v-if="card.text"
                    class="community__card-text"
                  >
                    {{ card.text }}
                  </p>
                  <div
                    v-if="card.comment"
                    class="community__card-comment"
                  >
                    {{ card.comment }}
                  </div>

                  <div
                    v-if="card.dateText"
                    class="community__card-date"
                  >
                    {{ card.dateText }}
                  </div>
                </div>

                <div
                  v-if="card.productUrl"
                  class="community__card-product"
                >
                  <span>
                    <div class="community__card-product_hover">
                      <span>+{{ card.productCount || 0 }}</span>
                    </div>

                    <img
                      class="community__card-product-image"
                      :src="card.productUrl"
                      :alt="card.productUrl"
                    >
                  </span>
                </div>

                <div
                  v-if="card.button"
                  class="community__card-button"
                >
                  {{ card.button }}
                </div>
              </div>
            </div>
          </TransitionGroup>
        </div>

        <div class="community__right">
          <div class="community__right-text-block">
            <p class="community__right-text">
              {{ $t('components.home.old.community.text1') }}
            </p>
            <p class="community__right-text">
              <strong>{{ $t('components.home.old.community.text2') }}</strong>
              {{ $t('components.home.old.community.text3') }}
            </p>
            <p class="community__right-text">
              <strong>{{ $t('components.home.old.community.text4') }}</strong>
              {{ $t('components.home.old.community.text5') }}
            </p>
          </div>

          <div class="community__right-link-block">
            <a
              v-if="!isAuth"
              class="community__right-link"
              href="/login"
              @click.prevent="handleClick"
            >{{ $t('components.home.old.community.createAccount') }}</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
type TCard = {
  id: number
  avatarUrl?: string
  info?: string
  title?: string
  text?: string
  dateText?: string
  productUrl?: string
  productCount?: string
  button?: string
  comment?: string
}

let interval: number;

const { t } = useI18n();
const { isAuth, openAuthDialog } = useAccountStore();

const currentCard = ref<TCard | null>(null);
const communityCards = ref<TCard[]>([
  {
    id: 1,
    avatarUrl: '//static.oskelly.ru/images/icons/mask_user_1.jpg',
    info: 'like',
    title: t('components.home.old.community.communityCard1.title'),
    text: t('components.home.old.community.communityCard1.text'),
    dateText: t('components.home.old.community.communityCard1.dateText'),
    productUrl: '//static.oskelly.ru/images/icons/mask_img_2.png',
    productCount: '4',
  },
  {
    id: 2,
    avatarUrl: '//static.oskelly.ru/images/icons/mask_user_2.jpg',
    info: 'friend',
    title: t('components.home.old.community.communityCard2.title'),
    text: t('components.home.old.community.communityCard2.text'),
    dateText: t('components.home.old.community.communityCard2.dateText'),
    button: t('components.home.old.community.communityCard2.button'),
  },
  {
    id: 3,
    title: t('components.home.old.community.communityCard3.title'),
    text: t('components.home.old.community.communityCard3.text'),
    dateText: t('components.home.old.community.communityCard3.dateText'),
    productUrl: '//static.oskelly.ru/images/icons/mask_img_1.png',
    productCount: '4',
  },
  {
    id: 4,
    title: t('components.home.old.community.communityCard4.title'),
    text: t('components.home.old.community.communityCard4.text'),
    dateText: t('components.home.old.community.communityCard4.dateText'),
  },
  {
    id: 5,
    avatarUrl: '//static.oskelly.ru/images/icons/mask_user_1.jpg',
    info: 'comment',
    text: t('components.home.old.community.communityCard5.text'),
    dateText: t('components.home.old.community.communityCard5.dateText'),
  },
  {
    id: 6,
    title: 'ivandansky',
    text: t('components.home.old.community.communityCard6.text'),
    dateText: t('components.home.old.community.communityCard6.dateText'),
    productUrl: '//static.oskelly.ru/images/icons/mask_img_3.png',
    productCount: '4',
  },
  {
    id: 7,
    title: t('components.home.old.community.communityCard7.title'),
    text: t('components.home.old.community.communityCard7.text'),
    dateText: t('components.home.old.community.communityCard7.dateText'),
    productUrl: '//static.oskelly.ru/images/icons/mask_img_2.png',
    productCount: '4',
  },
  {
    id: 8,
    title: t('components.home.old.community.communityCard8.title'),
    text: t('components.home.old.community.communityCard8.text'),
    dateText: t('components.home.old.community.communityCard8.dateText'),
  },
  {
    id: 9,
    avatarUrl: '//static.oskelly.ru/images/icons/mask_user_1.jpg',
    info: 'comment',
    title: t('components.home.old.community.communityCard9.title'),
    text: t('components.home.old.community.communityCard9.text'),
    comment: t('components.home.old.community.communityCard9.comment'),
    dateText: t('components.home.old.community.communityCard9.dateText'),
    productUrl: '//static.oskelly.ru/images/icons/mask_img_2.png',
    productCount: '4',
  },
]);

function handleClick() {
  if (!isAuth.value) {
    openAuthDialog({ chapter: 'create_account' });
  }
}

function onLeave(el: HTMLElement, done: () => void) {
  el.style.transform = `translateY(-${el.clientHeight}px)`;

  setTimeout(() => {
    if (currentCard.value) {
      communityCards.value.push(currentCard.value);
    }

    done();
  }, 500);
}

onMounted(() => {
  interval = window.setInterval(() => {
    const card = communityCards.value.shift();

    if (card) currentCard.value = card;
  }, 3000);
});

onUnmounted(() => {
  window.clearInterval(interval);
});
</script>

<style scoped lang="scss">
.scroll-top-move,
.scroll-top-enter-active,
.scroll-top-leave-active {
  transition: all 0.5s ease-out;
}

.scroll-top-leave-active {
  position: absolute;
}

.community {
  padding: 33px 0;
  background: #fafafa;

  @media screen and (min-width: 767px) {
    padding: 54px 0 28px;
  }

  @media screen and (min-width: 1024px) {
    padding: 73px 0 60px;
  }

  .section-title {
    margin-bottom: 20px;

    @media screen and (min-width: 767px) {
      text-align: center;
      margin-bottom: 45px;
    }

    @media screen and (min-width: 1024px) {
      margin-bottom: 60px;
    }
  }

  &__content {
    @media screen and (min-width: 767px) {
      display: flex;
      max-width: 1144px;
      margin: 0 auto;
    }
  }

  &__left {
    margin-bottom: 16px;

    &:deep(.community__cards) {
      position: relative;
      overflow: hidden;
      height: 400px;
      width: 100%;
    }

    @media screen and (min-width: 767px) {
      width: 300px;
      margin-bottom: 0;
      flex-shrink: 0;
    }

    @media screen and (min-width: 1024px) {
      width: 400px;
    }
  }

  &__card {
    width: 100%;
    padding-bottom: 10px;

    &:last-child {
      padding-bottom: 0;
    }

    @media screen and (min-width: 767px) {
      padding-bottom: 24px;
    }

    @media screen and (min-width: 1024px) {
      padding-bottom: 32px;
    }

    &-inner {
      width: 100%;
      background: #fff;
      padding: 16px 5px 14px;
      display: flex;
      align-items: flex-start;

      @media screen and (min-width: 1024px) {
        padding: 18px 16px 16px;
      }
    }

    &-avatar {
      flex-shrink: 0;
      width: 38px;
      height: 38px;
      position: relative;
      border-radius: 50%;
      background: url('//static.oskelly.ru/images/icons/left_img_user_bg.svg') center center no-repeat #e8e8e8;

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0px;
        width: 12px;
        height: 12px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100%;

        @media screen and (min-width: 1024px) {
          right: -3px;
          width: 18px;
          height: 18px;
        }
      }

      &_comment:before {
        background-image: url('//static.oskelly.ru/images/icons/ic_alert_comment_home.svg');
      }

      &_friend:before {
        background-image: url('//static.oskelly.ru/images/icons/ic_alert_friend_home.svg');
      }

      &_like:before {
        background-image: url('https://static.oskelly.ru/images/icons/ic_alert_like _home.svg');
      }

      @media screen and (min-width: 1024px) {
        width: 47px;
        height: 47px;
      }
    }

    &-avatar-image {
      width: 100%;
      height: 100%;
      display: block;
    }

    &-content {
      padding: 4px 8px;

      @media screen and (min-width: 1024px) {
        padding: 5px 14px;
      }
    }

    &-title {
      font-size: 13px;
      line-height: 16px;
      font-weight: 700;
      color: #333;
      margin-bottom: 2px;
    }

    &-text {
      font-size: 13px;
      line-height: 16px;
      color: #333;
      margin-bottom: 4px;
    }

    &-comment {
      font-size: 11px;
      line-height: 14px;
      margin-bottom: 4px;
      margin-top: 8px;
      color: #828282;
      padding: 8px;
      background: #f2f2f2;
    }

    &-date {
      color: #828282;
      font-size: 12px;
      line-height: 15px;
    }

    &-product {
      flex-shrink: 0;
      width: 33px;
      height: 33px;
      position: relative;
      overflow: hidden;
      border-radius: 2px;
      font-size: 14px;
      color: #333;
      margin-left: auto;

      &:hover {
        .community__card-product_hover {
          opacity: 1;
        }
      }

      @media screen and (min-width: 1024px) {
        width: 44px;
        height: 44px;
      }
    }

    &-product_hover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.4);
      opacity: 0;
      transition: .3s;
      color: #fff;
      font-size: 11px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: default;
    }

    &-product-image {
      width: 100%;
      height: 100%;
      display: block;
    }

    &-button {
      transition: .3s;
      color: #fff;
      background: #000;
      text-align: center;
      border-radius: 2px;
      padding: 8px 16px;
      font-size: 12px;
      line-height: 15px;
      font-weight: 600;
      margin-left: auto;
      margin-top: 12px;

      &:hover {
        background: #505050;
      }
    }
  }

  &__right {
    @media screen and (min-width: 767px) {
      padding: 26px 0 0 46px;
    }

    @media screen and (min-width: 1024px) {
      padding: 68px 50px 0;
      max-width: 747px;
    }

    @media screen and (min-width: 1200px) {
      padding: 68px 100px 0 112px;
    }
  }

  &__right-text {
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 10px;

    @media screen and (min-width: 1024px) {
      font-size: 16px;
    }
  }

  &__right-link-block {
    text-align: center;
    margin-top: 18px;

    @media screen and (min-width: 1024px) {
      text-align: left;
    }
  }

  &__right-link {
    font-size: 14px;
    line-height: 17px;
    color: #828282;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
